<template>
  <div class="session">
    同屏会话
  </div>
</template>

<script>
export default {
  name: "session"
};
</script>
